import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const aboutUsSettingsApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetAboutUs();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (aboutUsSettings: CreDtos.AboutUsSettings) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostAboutUs();
        query.aboutUsSettings = aboutUsSettings;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/aboutUsSettings.service.ts